import React from 'react';
import Loader from '@cpg-its/ads.common.loading-circle';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { usePlanSummary } from '../plan-summary/usePlanSummary';
import { TcsmEpiApiState, TcsmStates } from '../../../../../root/tcsm-model';
import { OePlanOfferings } from '../institution-model';
import { DeclineMedicalDentalWizard } from './wizard/decline-medical-dental-wizard';
import DeclineMedicalDentalForm from './decline-medical-dental-form';
import { useBasePath } from '../../../../../global/hooks/useBasePath';
import { ArcRoutes } from '../../../constants/routes';


function DeclineMedicalDental() {

	const institutionClientNumber = useSelector<TcsmStates, string>(state => state?.institutionState?.institutionClientNumber);
	const oePlanOfferings = useSelector<TcsmStates, OePlanOfferings>(state => state?.institutionState?.oePlanOffering);
	const loaded = usePlanSummary(institutionClientNumber);
	const dispatch = useDispatch();
	const history = useHistory();
	const successUrl = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.InstitutionRoot}${ArcRoutes.PlanSummary}`);

	const epiContent = useSelector<TcsmStates, TcsmEpiApiState>(state => state?.epiProps);
	if (!loaded) {
		return <Loader />;
	}

	const wizard = new DeclineMedicalDentalWizard(dispatch, history, epiContent, oePlanOfferings, successUrl);

	return (
		<DeclineMedicalDentalForm wizard={wizard} />
	);
}


export default DeclineMedicalDental;